import { ok } from "neverthrow";

import { mustBeDefined, takeFirst } from "@thalamos/common";

import type { IncidentWorkItemWithContext } from "../types/incidentWorkItem.js";
import { combinePlacesOfSafetyAndOfficerPresenceForms } from "./combinePlacesOfSafetyAndOfficerPresenceForms.js";

export const getLatestPlaceOfSafetyForm = (
  incidentWorkItem: IncidentWorkItemWithContext | undefined,
) => {
  return ok(incidentWorkItem)
    .andThen(mustBeDefined("incidentWorkItem is undefined"))
    .andThen(combinePlacesOfSafetyAndOfficerPresenceForms)
    .andThen(takeFirst("No places of safety found"))
    .map((pos) => pos.placeOfSafety.form);
};
